// @ts-nocheck
import React from 'react';
import { FONT_STYLES, TEMPLATES } from '../data/initialData';
import './TemplatePicker.css';

const COLOR_PRESETS = [
  '#1a365d', '#0f766e', '#18181b', '#7c2d12', '#1d4ed8',
  '#6d28d9', '#b45309', '#059669', '#dc2626', '#0e7490',
  '#be185d', '#4338ca', '#065f46', '#92400e', '#1e3a5f',
];

export default function TemplatePicker({
  selected,
  onSelect,
  customColor,
  onColorChange,
  selectedFontStyle = 'template',
  onFontStyleChange,
}) {
  const currentTemplate = TEMPLATES.find((t) => t.id === selected) || TEMPLATES[0];
  const effectiveAccent = customColor || currentTemplate.accent;
  const currentFontStyle = FONT_STYLES.find((font) => font.id === selectedFontStyle) || FONT_STYLES[0];

  return (
    <div className="tp-bar">
      <div className="tp-bar-inner">
        <span className="tp-bar-label">TEMPLATE</span>
        <button
          className="tp-current-btn"
          type="button"
          style={{ borderColor: effectiveAccent, color: effectiveAccent }}
        >
          <span className="tp-current-dot" style={{ background: effectiveAccent }} />
          {currentTemplate.name}
        </button>

        <button
          className="tp-current-btn tp-current-font"
          type="button"
          style={{
            borderColor: effectiveAccent,
            color: effectiveAccent,
            fontFamily: currentFontStyle.fontFamily || currentTemplate.fontFamily,
          }}
        >
          Aa {currentFontStyle.name}
        </button>

        <div className="tp-color-strip">
          <span className="tp-bar-label">COLOR</span>
          {COLOR_PRESETS.map((c) => (
            <button
              key={c}
              className={`tp-color-dot ${effectiveAccent === c ? 'tp-color-dot--active' : ''}`}
              style={{ background: c, outline: effectiveAccent === c ? `1px solid ${c}` : 'none' }}
              onClick={() => onColorChange(c)}
              title={c}
            />
          ))}
          <input
            type="color"
            className="tp-color-custom"
            value={effectiveAccent}
            onChange={(e) => onColorChange(e.target.value)}
            title="Custom color"
          />
        </div>
      </div>

      <div className="tp-panel">
        <div className="tp-panel-header">
          <span className="tp-panel-title">Choose a Template</span>
        </div>
        <div className="tp-grid">
          {TEMPLATES.map((t) => {
            const accent = customColor || t.accent;
            return (
              <button
                key={t.id}
                className={`tp-card ${selected === t.id ? 'tp-card--active' : ''}`}
                onClick={() => onSelect(t.id)}
                style={{ '--card-accent': accent }}
              >
                <div className="tp-thumb" style={{ fontFamily: t.fontFamily }}>
                  <MiniThumb style={t.style} accent={accent} headingFont={t.headingFont} />
                </div>
                <div className="tp-card-label">
                  <span className="tp-card-name">{t.name}</span>
                  <span className="tp-card-desc">{t.description}</span>
                </div>
                {selected === t.id && <span className="tp-card-check">✓</span>}
              </button>
            );
          })}
        </div>

        {onFontStyleChange && (
          <div className="tp-font-section">
            <div className="tp-panel-header">
              <span className="tp-panel-title">Choose a Font Style</span>
            </div>
            <div className="tp-font-grid">
              {FONT_STYLES.map((font) => {
                const bodyFont = font.fontFamily || currentTemplate.fontFamily;
                const headingFont = font.headingFont || currentTemplate.headingFont;
                return (
                  <button
                    key={font.id}
                    type="button"
                    className={`tp-font-card ${
                      currentFontStyle.id === font.id ? 'tp-font-card--active' : ''
                    }`}
                    onClick={() => onFontStyleChange(font.id)}
                    style={{ '--card-accent': effectiveAccent, fontFamily: bodyFont }}
                  >
                    <span className="tp-font-sample" style={{ fontFamily: headingFont }}>
                      Aa
                    </span>
                    <span className="tp-font-meta">
                      <span className="tp-font-name">{font.name}</span>
                      <span className="tp-font-desc">{font.description}</span>
                    </span>
                    {currentFontStyle.id === font.id && <span className="tp-card-check">✓</span>}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function MiniThumb({ style, accent, headingFont }) {
  const line = (w, h = 3, color = '#e2e8f0', radius = 2) => (
    <div style={{ width: `${w}%`, height: h, background: color, borderRadius: radius, marginBottom: 3 }} />
  );

  if (style === 'sidebar') {
    return (
      <div style={{ display: 'flex', height: '100%', gap: 4 }}>
        <div style={{ width: '32%', background: accent, borderRadius: 2, padding: 5 }}>
          <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'rgba(255,255,255,0.4)', margin: '0 auto 4px' }} />
          {line(80, 2, 'rgba(255,255,255,0.5)')}
          {line(60, 2, 'rgba(255,255,255,0.3)')}
        </div>
        <div style={{ flex: 1, padding: '4px 0' }}>
          <div style={{ fontSize: 7, fontWeight: 800, color: accent, fontFamily: headingFont, marginBottom: 2 }}>JOHN DOE</div>
          {line(90, 2, '#ddd')}
          <div style={{ fontSize: 5, color: accent, fontWeight: 700, marginTop: 4, marginBottom: 2, borderBottom: `1px solid ${accent}` }}>EXPERIENCE</div>
          {line(100, 2)}{line(80, 2)}{line(90, 2)}
        </div>
      </div>
    );
  }

  if (style === 'bold') {
    return (
      <div style={{ height: '100%' }}>
        <div style={{ background: accent, padding: '6px 6px 5px', borderRadius: '2px 2px 0 0', marginBottom: 5 }}>
          <div style={{ fontSize: 8, fontWeight: 900, color: '#fff', fontFamily: headingFont, letterSpacing: 1 }}>JOHN DOE</div>
          <div style={{ fontSize: 5, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>john@email.com - linkedin</div>
        </div>
        <div style={{ padding: '0 4px' }}>
          <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', marginBottom: 2 }}>Experience</div>
          {line(100, 2)}{line(80, 2)}{line(90, 2)}
        </div>
      </div>
    );
  }

  if (style === 'elegant') {
    return (
      <div style={{ height: '100%', textAlign: 'center' }}>
        <div style={{ fontFamily: headingFont, fontSize: 8, fontWeight: 700, color: accent, textAlign: 'center', marginBottom: 1, fontStyle: 'italic' }}>John Doe</div>
        <div style={{ fontSize: 5, color: '#888', marginBottom: 3, textAlign: 'center' }}>email - phone - city</div>
        <div style={{ borderTop: `1.5px solid ${accent}`, borderBottom: `1.5px solid ${accent}`, padding: '2px 0', marginBottom: 4 }}>
          <div style={{ fontSize: 5, color: accent, fontFamily: headingFont, fontStyle: 'italic' }}>Summary goes here briefly</div>
        </div>
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: 5, color: accent, fontWeight: 700, borderBottom: `1px solid ${accent}`, marginBottom: 2 }}>EXPERIENCE</div>
          {line(100, 2)}{line(75, 2)}
        </div>
      </div>
    );
  }

  if (style === 'creative') {
    return (
      <div style={{ height: '100%', borderLeft: `3px solid ${accent}`, paddingLeft: 5 }}>
        <div style={{ fontSize: 8, fontWeight: 800, color: accent, fontFamily: headingFont, marginBottom: 1 }}>John Doe</div>
        <div style={{ fontSize: 5, color: '#888', marginBottom: 4 }}>email - phone - city</div>
        <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', marginBottom: 2 }}>Experience</div>
        {line(100, 2)}{line(80, 2)}{line(90, 2)}
      </div>
    );
  }

  if (style === 'compact') {
    return (
      <div style={{ height: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderBottom: `2px solid ${accent}`, paddingBottom: 3, marginBottom: 3 }}>
          <div style={{ fontSize: 8, fontWeight: 900, color: accent, fontFamily: headingFont }}>JOHN DOE</div>
          <div style={{ fontSize: 4, color: '#666' }}>email - phone</div>
        </div>
        <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', marginBottom: 1 }}>Experience</div>
        {line(100, 2)}{line(80, 2)}
        <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', marginBottom: 1, marginTop: 3 }}>Skills</div>
        <div style={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          {['React', 'Node', 'SQL'].map(s => <span key={s} style={{ fontSize: 4, background: `${accent}18`, color: accent, padding: '1px 3px', borderRadius: 2 }}>{s}</span>)}
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: '100%' }}>
      <div style={{ fontFamily: headingFont, fontSize: style === 'minimal' ? 7 : 8, fontWeight: style === 'minimal' ? 900 : 700, color: accent, marginBottom: 1, textTransform: style === 'minimal' ? 'uppercase' : 'none', fontStyle: style === 'executive' ? 'italic' : 'normal', letterSpacing: style === 'minimal' ? 1 : 0 }}>
        {style === 'tech' ? '> John Doe' : 'John Doe'}
      </div>
      <div style={{ fontSize: 5, color: '#888', marginBottom: 4 }}>email - phone - city</div>
      <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', letterSpacing: style === 'tech' ? 1 : 0.5, borderBottom: `1px solid ${accent}`, paddingBottom: 1, marginBottom: 3, fontFamily: style === 'tech' ? 'monospace' : 'inherit' }}>Experience</div>
      {line(100, 2)}{line(80, 2)}{line(90, 2)}
      <div style={{ fontSize: 5, color: accent, fontWeight: 700, textTransform: 'uppercase', borderBottom: `1px solid ${accent}`, paddingBottom: 1, marginBottom: 3, marginTop: 4 }}>Skills</div>
      {line(70, 2)}{line(90, 2)}
    </div>
  );
}
